import { render, staticRenderFns } from "./WkFormItems.vue?vue&type=template&id=065a26c2&scoped=true"
import script from "./WkFormItems.vue?vue&type=script&lang=js"
export * from "./WkFormItems.vue?vue&type=script&lang=js"
import style0 from "./WkFormItems.vue?vue&type=style&index=0&id=065a26c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a26c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065a26c2')) {
      api.createRecord('065a26c2', component.options)
    } else {
      api.reload('065a26c2', component.options)
    }
    module.hot.accept("./WkFormItems.vue?vue&type=template&id=065a26c2&scoped=true", function () {
      api.rerender('065a26c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkForm/WkFormItems.vue"
export default component.exports